<template src="../templates/normal_fcont_151.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'

import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink'
import UseDesignPaperList from '../components/UseDesignPaperList'
import PrintButton from '../components/PrintButton'
import ReleaseDateForArticle from '../components/ReleaseDateForArticle'
import CreatorProfileMaikaKokubo from '../components/CreatorProfileMaikaKokubo'
import InfoMachineTranslation from '../components/InfoMachineTranslation'
import AppDownloadiPrint from '../components/AppDownloadiPrint'
import AppDownloadSmartPanel from '../components/AppDownloadSmartPanel'
import AppDownloadCreative from '../components/AppDownloadCreative'
import { Carousel,Slide } from 'uiv'

export default {
  name: 'app',
  data() {
    return {
      articleId: '151',
      app_root: process.env.VUE_APP_ROOT
    };
  },
  components: {
    LabelFunMessage, Carousel,Slide,FuncSearchRecommendLink,
    FuncSearchGalleryQR,
    UseDesignPaperList,PrintButton,ReleaseDateForArticle,CreatorProfileMaikaKokubo,
    InfoMachineTranslation,AppDownloadiPrint,AppDownloadSmartPanel,AppDownloadCreative
  },
  computed: {
  },
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['151-1'],
      meta: [
        { name: 'description', content: this.$store.state.messages.messages['151-3']}
      ]
    };
  }
  
};
</script>
<style scoped>
</style>

